<template>
  <div class="modal" :class="{'is-active':isActive}">
    <div class="modal-background"></div>
    <div class="modal-content">
      <i class="iconfont iconguanbi" @click="$emit('close')"></i>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isActive']
}
</script>

<style lang="scss" scoped>
@import '../../style/app.sass';

.modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  display: none;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 100vh;
  z-index: 100000;
  &.is-active {
    display: flex;
  }

  .modal-background {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    background-color: rgba(53,53,53,.86);
  }

  .modal-content {
    width: 1000px;
    position: relative;
    .iconfont {
      font-size: 25px;
      color: #fff;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      transform: translateY(calc(-100% - 5px)) rotate(45deg);
    }
    @include mobile {
      width: 100%;
    }
  }
}
</style>
